module.exports = __webpack_public_path__ + "tl.e50237d4da13ed40afdc.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tl.svg
// module chunks = styles